import { useQuery } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';

export interface OnboardingOption {
  slug: string;
  title: string;
  description?: string;
  bullets?: string[];
  image?: string; // For step 1
  order?: number;
}

export interface OnboardingMasterData {
  title: string;
  subtitle: string;
  type: string;
  options: OnboardingOption[];
}

export const fetchOnboardingMasterData = async () => {
  const apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_GET_ONBOARDING_MASTER_DATA}`;
  const response = await fetch(apiUrl);

  if (!response.ok) {
    throw new Error('Failed to fetch master data');
  }

  const res = await response.json();
  const data = res.data as Record<string, OnboardingMasterData>;

  // Sort options by 'order' if it exists
  Object.values(data).forEach((category) => {
    if (category.options && Array.isArray(category.options)) {
      category.options.sort((a, b) => {
        const orderA = a.order ?? 999;
        const orderB = b.order ?? 999;
        return orderA - orderB;
      });
    }
  });

  return data;
};

export function useGetOnboardingMasterData() {
  return useQuery({
    queryKey: ['onboarding-master-data'],
    queryFn: fetchOnboardingMasterData,
    staleTime: 1000 * 60 * 60, // 1 hour
  });
}
